export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f2f466210977f9eb4d5a4cf61e7f6862652f2f60e&name=fetchTypeahead!'